<template>
  <div class="notification-wrap" :class="classes">
    <template v-if="type === 'match_started'">
      <div class="title">Ваша игра <span>готова!</span></div>
      <MatchRoomButton @clicked="navigateAndClose" :match="match" />
      <div class="subtitle">Жми!</div>
    </template>
    <template v-else>
      <div v-if="notify.title" class="title" v-text="notify.title" />
      <div v-if="notify.text" class="text" v-html="notify.text" />

      <div class="notification-actions" v-if="showRoomAction">
        <div v-if="['right', 'center'].includes(btnAlign)" class="spacer"></div>
        <app-btn v-bind="matchBtnAttrs" @click="$modals.close()"
          >Перейти в комнату матча</app-btn
        >
        <div v-if="['left', 'center'].includes(btnAlign)" class="spacer"></div>
      </div>
    </template>
  </div>
</template>

<script>
import MatchRoomButton from "@/components/tournament/MatchRoomButton";
import StartedMatchSound from "@/assets/match-started.mp3";

export default {
  components: { MatchRoomButton },

  props: {
    type: {
      type: String,
      required: false
    },
    options: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      closeTimeout: null
    };
  },

  computed: {
    match() {
      return this.options.match || {};
    },

    notifysContent() {
      const matchNum = this.match.id ? ` <b>#${this.match.id}</b>` : "";
      return {
        player_promoted: {
          title: "Новый матч",
          text:
            "Вы были продвинуты в следующую стадию турнира, но ваш соперник еще не определился.<br /><br />Как только матч будет готов, мы оповестим вас!"
        },

        should_confirm_score_side: {
          title: "Подтвердите результат",
          text: `Ваш соперник указал результат матча${matchNum}.<br />Пожалуйста, подтвердите его или укажите свой результат.`
        },

        score_not_confirmed: {
          title: "Статус матча изменён",
          text: `<b>Внимание!</b> Счёт в&nbsp;матче${matchNum}&nbsp;не подтвержден.<br />Уведомление отправлено судье.`
        },

        score_confirmed: {
          title: this.isWinner
            ? "Поздравляем!"
            : "Результат успешно подтвержден.",
          text: this.isWinner
            ? "Результат успешно подтвержден. Ожидайте продвижения по сетке."
            : null
        },

        technical_loose: {
          title: "Статус матча изменён",
          text: `<b>Внимание!</b> Согласно решению судьи в&nbsp;матче${matchNum}&nbsp; объявлено <b>техническое поражение</b>.`
        },

        two_winners: {
          title: "Поздравляем!",
          text:
            "Вы стали финалистом квалификации <br />и сможете учавствовать в Гранд Финале."
        }
      };
    },

    notify() {
      let { [this.type]: content } = this.notifysContent;
      return content || {};
    },

    classes() {
      return {
        [this.type]: !!this.type
      };
    },

    playerSide() {
      return this.options.playerSide || null;
    },

    isWinner() {
      return (
        this.match.winner && this.playerSide === `player${this.match.winner}`
      );
    },

    showRoomAction() {
      return this.options.showBtn || false;
    },

    btnAlign() {
      return this.options.btnAlign || "center";
    },

    matchBtnAttrs() {
      return {
        color: "yellow-grad",
        border: "bottom",
        to: {
          name: "tournament-match",
          params: {
            tournament_id: this.match.tournament_id,
            match_id: this.match.id
          }
        }
      };
    },

    timeout() {
      return (!this.showRoomAction && +this.options.timeout) || 0;
    }
  },

  mounted() {
    this.startTimeout();

    if (this.type == "match_started") {
      setTimeout(() => {
        let sound = new Audio(StartedMatchSound);
        sound.play();
      }, 300);
    }
  },

  beforeDestroy() {
    if (this.closeTimeout) clearTimeout(this.closeTimeout);
  },

  methods: {
    navigateAndClose(href) {
      this.$modals.close(href);
      if (href) this.$router.push(href);
    },

    startTimeout() {
      if (!this.timeout) return;

      this.closeTimeout = setTimeout(() => {
        this.$modals.close();
      }, this.timeout);
    }
  }
};
</script>

<style lang="scss">
.notification-modal.player_promoted {
  .modal-card {
    max-width: 500px;
  }
}

.notification-modal.match_started {
  .modal-card {
    background: none;
    box-shadow: none;

    @include breakpoint("xs-only") {
      .modal__close {
        right: 0;
      }
    }
  }

  .notification-wrap {
    padding: 0;

    .title {
      text-transform: uppercase;
      font-family: "Open sans";
      text-shadow: 0px 6px 8px rgba(0, 0, 0, 0.75);
      margin-bottom: 30px;
      user-select: none;

      font-size: 40px;
      line-height: 38px;
      letter-spacing: -0.03em;

      span {
        display: block;
        font-size: 70px;
        line-height: 68px;
      }

      @include breakpoint("xs-only") {
        font-size: 30px;
        line-height: 28px;

        span {
          font-size: 48px;
          line-height: 48px;
        }
      }
    }

    .subtitle {
      // text-transform: uppercase;
      font-family: "Open sans";
      text-shadow: 0px 6px 8px rgba(0, 0, 0, 0.75);
      margin-top: 20px;
      user-select: none;

      font-size: 20px;
      line-height: 18px;
      font-weight: bold;
    }
  }
}

.notification {
  &-modal {
    color: #fff;
    line-height: 1.47em;

    .modal-card {
      padding: 0px;
    }
  }

  &-wrap {
    // background: rgba(#000a25, 0.5);
    text-align: center;
    padding: 16px;
    border-radius: 6px;
    padding: 30px;
    box-sizing: border-box;

    font-size: 18px;
    line-height: 1.47em;
    text-align: center;

    .title {
      font-weight: bold;
      font-size: 30px;
      line-height: 40px;
      margin-bottom: 12px;
    }

    &.type__warning {
      border: 2px solid rgba(#e72f31, 0.5);

      .title {
        color: #e72f31;
      }
    }
  }

  &-actions {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
